import { forum_api_list_of_forums_anonymous_url, forum_api_list_of_forums_url } from 'mk/urls/functions';
import { forumHeaderUpdate, LastVisitCounts } from 'mk2/apps/forum/actions';
import { TopicEntity, TopicSchema } from 'mk2/apps/forum/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { listOfForumsFetch, ListOfForumsLoadAction, LIST_OF_FORUMS_LOAD } from './ListOfForums.actions';

const logger = getLogger('forum/ListOfForums.sagas');

interface ApiResponse {
    body: {
        contestsTopic: TopicEntity;
        followingTopics: TopicEntity[];
        hasNext: number;
        hasPrevious: number;
        lastVisitCounts: LastVisitCounts;
        testingsTopic: TopicEntity;
        topics: TopicEntity[];
    };
}

function* fetchListOfForums({ username, after, xhr }: ListOfForumsLoadAction & XHRAction) {
    yield put(listOfForumsFetch.request(username, after));

    try {
        const response: ApiResponse = yield call(
            () => xhr.get(
                username === 'anonymous'
                    ? forum_api_list_of_forums_anonymous_url()
                    : forum_api_list_of_forums_url(username),
                { after },
            ),
        );
        const normalizedResponse = normalize(response.body, {
            contestsTopic: TopicSchema,
            followingTopics: [TopicSchema],
            testingsTopic: TopicSchema,
            topics: [TopicSchema],
        });
        yield put(listOfForumsFetch.success(username, after, response.body.hasNext, response.body.hasPrevious, normalizedResponse));
        yield put(forumHeaderUpdate(response.body.lastVisitCounts));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(listOfForumsFetch.failure(username, after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(LIST_OF_FORUMS_LOAD, fetchListOfForums),
    ]);
}
